
































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { 認証型 } from '@/type/authentication/authentication';
import {ValidationResult} from '@/type/validation/result';
import 小樽市立病院日付別発注実績明細表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院日付別発注実績明細表検索条件チェッカー';
import 小樽市立病院納入実績明細表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院納入実績明細表検索条件チェッカー';
import 小樽市立病院納入実績集計表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院納入実績集計表検索条件チェッカー';
import 小樽市立病院出庫実績集計表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院出庫実績集計表検索条件チェッカー';
import 小樽市立病院薬品別受払年報検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院薬品別受払年報検索条件チェッカー';
import 小樽市立病院メーカー別受入分析表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院メーカー別受入分析表検索条件チェッカー';
import 小樽市立病院薬品別受入分析表検索条件チェッカー from '@/type/custom/otaru/report/小樽市立病院薬品別受入分析表検索条件チェッカー';
import { progress } from '@/script/progress';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import Yearpicker from '@/components/datepicker/YearPicker.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import moment from 'moment';

import {
  日付別発注実績明細表出力条件型,
  納入実績明細表出力条件型,
  納入実績集計表出力条件型,
  出庫実績集計表出力条件型,
  薬品別受払年報出力条件型,
  メーカー別受入分析表出力条件型,
  薬品別受入分析表出力条件型,
  卸選択型,
  管理部署選択型,
  } from '@/type/custom/otaru/report/report';

@Component({
  components: {
    IconButton,
    ButtonPanel,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    Datepicker,
    Yearpicker,
    WholesaleSelector,
    DepartmentSelector,
  },
})
export default class ReceiveDetail extends Vue {

  出力開始日付: Date | null = null;
  出力終了日付: Date | null = null;
  日付別発注実績明細表出力条件: 日付別発注実績明細表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    卸コード: null,
  };
  納入実績明細表出力条件: 納入実績明細表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    卸コード: null,
  };
  納入実績集計表出力条件: 納入実績集計表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    卸コード: null,
    薬価区分: '現薬価',
  };
  出庫実績集計表出力条件: 出庫実績集計表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    出庫先: null,
    薬価区分: '現薬価',
    管理部署: null,
  };
  薬品別受払年報出力条件: 薬品別受払年報出力条件型 = {
    期間指定方法: '日付',
    出力対象開始日: null,
    出力対象終了日: null,
    対象年度: null,
    薬価区分: '現薬価',
    管理部署: null,
  };
  メーカー別受入分析表出力条件: メーカー別受入分析表出力条件型 = {
    期間指定方法: '日付',
    出力対象開始日: null,
    出力対象終了日: null,
    対象年度: null,
    薬価区分: '現薬価',
    順位: 300,
  };
  薬品別受入分析表出力条件: 薬品別受入分析表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    対象年度: null,
    薬価有無: '指定なし',
    薬価区分: '現薬価',
    順位: 300,
  };
  アラートメッセージ: string | string[] | null = null;

  created(): void {
    moment.locale('ja');
    this.initialize();
  }

  initialize() {
    this.日付別発注実績明細表出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
      卸コード: null,
    };
    this.納入実績明細表出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
      卸コード: null,
    };
    this.納入実績集計表出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
      卸コード: null,
      薬価区分: '現薬価',
    };
    this.出庫実績集計表出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
      出庫先: null,
      薬価区分: '現薬価',
      管理部署: null,
    };
    this.薬品別受払年報出力条件 = {
      期間指定方法: '日付',
      出力対象開始日: null,
      出力対象終了日: null,
      対象年度: null,
      薬価区分: '現薬価',
      管理部署: null,
    };
    this.メーカー別受入分析表出力条件 = {
      期間指定方法: '日付',
      出力対象開始日: null,
      出力対象終了日: null,
      対象年度: null,
      薬価区分: '現薬価',
      順位: 300,
    };
    this.薬品別受入分析表出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
      対象年度: null,
      薬価有無: '指定なし',
      薬価区分: '現薬価',
      順位: 300,
    };
  }

  download() {
    this.ダイアログを開く('小樽市立病院帳票ダウンロード確認ダイアログ');
  }

  clear() {
    this.出力開始日付 = null;
    this.出力終了日付 = null;
  }

  ダウンロードする() {
    this.ダイアログを閉じる('小樽市立病院帳票ダウンロード確認ダイアログ');
    // TODO: DL実装
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  日付別発注実績明細表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院日付別発注実績明細表検索条件チェッカー(this.日付別発注実績明細表出力条件);
    return checker.hasError(項目名);
  }

  async 日付別発注実績明細表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.日付別発注実績明細表出力条件) {
      return;
    }
    const checker = new 小樽市立病院日付別発注実績明細表検索条件チェッカー(this.日付別発注実績明細表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('日付別発注実績明細表ダウンロード確認ダイアログ');
  }

  async 日付別発注実績明細表を出力する(): Promise<void> {
    this.ダイアログを閉じる('日付別発注実績明細表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.日付別発注実績明細表を出力する('日付別発注実績明細表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.日付別発注実績明細表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 日付別発注実績明細表を出力するハンドラ(): Promise<void> {
    await progress(this.日付別発注実績明細表を出力する);
  }

  納入実績明細表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院納入実績明細表検索条件チェッカー(this.納入実績明細表出力条件);
    return checker.hasError(項目名);
  }

  async 納入実績明細表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.納入実績明細表出力条件) {
      return;
    }
    const checker = new 小樽市立病院納入実績明細表検索条件チェッカー(this.納入実績明細表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('納入実績明細表ダウンロード確認ダイアログ');
  }

  async 納入実績明細表を出力する(): Promise<void> {
    this.ダイアログを閉じる('納入実績明細表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.納入実績明細表を出力する('納入実績明細表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.納入実績明細表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 納入実績明細表を出力するハンドラ(): Promise<void> {
    await progress(this.納入実績明細表を出力する);
  }

  納入実績集計表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院納入実績集計表検索条件チェッカー(this.納入実績集計表出力条件);
    return checker.hasError(項目名);
  }

  async 納入実績集計表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.納入実績集計表出力条件) {
      return;
    }
    const checker = new 小樽市立病院納入実績集計表検索条件チェッカー(this.納入実績集計表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('納入実績集計表ダウンロード確認ダイアログ');
  }

  async 納入実績集計表を出力する(): Promise<void> {
    this.ダイアログを閉じる('納入実績集計表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.納入実績集計表を出力する('納入実績集計表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.納入実績集計表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 納入実績集計表を出力するハンドラ(): Promise<void> {
    await progress(this.納入実績集計表を出力する);
  }

  出庫実績集計表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院出庫実績集計表検索条件チェッカー(this.出庫実績集計表出力条件);
    return checker.hasError(項目名);
  }

  async 出庫実績集計表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.出庫実績集計表出力条件) {
      return;
    }
    const checker = new 小樽市立病院出庫実績集計表検索条件チェッカー(this.出庫実績集計表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('出庫実績集計表ダウンロード確認ダイアログ');
  }

  async 出庫実績集計表を出力する(): Promise<void> {
    const now = new Date();
    await download.出庫実績集計表を出力する('出庫実績集計表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.出庫実績集計表出力条件)
      .catch(this.サーバリクエストエラートラップ);
    this.ダイアログを閉じる('出庫実績集計表ダウンロード確認ダイアログ');
  }

  async 出庫実績集計表を出力するハンドラ(): Promise<void> {
    await progress(this.出庫実績集計表を出力する);
  }

  薬品別受払年報出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院薬品別受払年報検索条件チェッカー(this.薬品別受払年報出力条件);
    return checker.hasError(項目名);
  }

  薬品別受払年報出力期間指定方法判定(期間指定方法: string): boolean {
    return this.薬品別受払年報出力条件.期間指定方法 !== 期間指定方法;
  }

  薬品別受払年報の対象日付年度のクリア(期間指定方法: string): void {
    if (this.薬品別受払年報出力期間指定方法判定(期間指定方法)) {
      this.薬品別受払年報出力条件.出力対象開始日 = null;
      this.薬品別受払年報出力条件.出力対象終了日 = null;
      this.薬品別受払年報出力条件.対象年度 = null;
    }
  }

  async 薬品別受払年報ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.薬品別受払年報出力条件) {
      return;
    }
    const checker = new 小樽市立病院薬品別受払年報検索条件チェッカー(this.薬品別受払年報出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('薬品別受払年報ダウンロード確認ダイアログ');
  }

  async 薬品別受払年報を出力する(): Promise<void> {
    this.ダイアログを閉じる('薬品別受払年報ダウンロード確認ダイアログ');
    const now = new Date();
    await download.薬品別受払年報を出力する('薬品別受払年報_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.薬品別受払年報出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 薬品別受払年報を出力するハンドラ(): Promise<void> {
    await progress(this.薬品別受払年報を出力する);
  }

  メーカー別受入分析表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院メーカー別受入分析表検索条件チェッカー(this.メーカー別受入分析表出力条件);
    return checker.hasError(項目名);
  }

  メーカー別受入分析表出力期間指定方法判定(期間指定方法: string): boolean {
    return this.メーカー別受入分析表出力条件.期間指定方法 !== 期間指定方法;
  }

  メーカー別受入分析表の対象日付年度のクリア(期間指定方法: string): void {
    if (this.メーカー別受入分析表出力期間指定方法判定(期間指定方法)) {
      this.メーカー別受入分析表出力条件.出力対象開始日 = null;
      this.メーカー別受入分析表出力条件.出力対象終了日 = null;
      this.メーカー別受入分析表出力条件.対象年度 = null;
    }
  }

  async メーカー別受入分析表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.メーカー別受入分析表出力条件) {
      return;
    }
    const checker = new 小樽市立病院メーカー別受入分析表検索条件チェッカー(this.メーカー別受入分析表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('メーカー別受入分析表ダウンロード確認ダイアログ');
  }

  async メーカー別受入分析表を出力する(): Promise<void> {
    this.ダイアログを閉じる('メーカー別受入分析表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.メーカー別受入分析表を出力する('メーカー別受入分析表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.メーカー別受入分析表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async メーカー別受入分析表を出力するハンドラ(): Promise<void> {
    await progress(this.メーカー別受入分析表を出力する);
  }

  薬品別受入分析表出力条件エラー判定(項目名: string): boolean {
    const checker = new 小樽市立病院薬品別受入分析表検索条件チェッカー(this.薬品別受入分析表出力条件);
    return checker.hasError(項目名);
  }

  async 薬品別受入分析表JANダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.薬品別受入分析表出力条件) {
      return;
    }
    const checker = new 小樽市立病院薬品別受入分析表検索条件チェッカー(this.薬品別受入分析表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('薬品別受入分析表JANダウンロード確認ダイアログ');
  }

  async 薬品別受入分析表JANを出力する(): Promise<void> {
    this.ダイアログを閉じる('薬品別受入分析表JANダウンロード確認ダイアログ');
    const now = new Date();
    await download.薬品別受入分析表JANを出力する(
      '薬品別受入分析表（JAN）_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.薬品別受入分析表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 薬品別受入分析表JANを出力するハンドラ(): Promise<void> {
    await progress(this.薬品別受入分析表JANを出力する);
  }

  async 薬品別受入分析表厚生省ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.薬品別受入分析表出力条件) {
      return;
    }
    const checker = new 小樽市立病院薬品別受入分析表検索条件チェッカー(this.薬品別受入分析表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('薬品別受入分析表厚生省ダウンロード確認ダイアログ');
  }

  async 薬品別受入分析表厚生省を出力する(): Promise<void> {
    this.ダイアログを閉じる('薬品別受入分析表厚生省ダウンロード確認ダイアログ');
    const now = new Date();
    await download.薬品別受入分析表厚生省を出力する(
      '薬品別受入分析表（厚生省）_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.薬品別受入分析表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 薬品別受入分析表厚生省を出力するハンドラ(): Promise<void> {
    await progress(this.薬品別受入分析表厚生省を出力する);
  }

  async 薬品別受入分析表実績なしダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.薬品別受入分析表出力条件) {
      return;
    }
    const checker = new 小樽市立病院薬品別受入分析表検索条件チェッカー(this.薬品別受入分析表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('薬品別受入分析表実績なしダウンロード確認ダイアログ');
  }

  async 薬品別受入分析表実績なしを出力する(): Promise<void> {
    this.ダイアログを閉じる('薬品別受入分析表実績なしダウンロード確認ダイアログ');
    const now = new Date();
    await download.薬品別受入分析表実績なしを出力する(
      '薬品別受入分析表（実績なし）_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.薬品別受入分析表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 薬品別受入分析表実績なしを出力するハンドラ(): Promise<void> {
    await progress(this.薬品別受入分析表実績なしを出力する);
  }

  async サーバリクエストエラートラップ(error: any) {
    if (!error.data.errors) {
      this.showAlert(error.data.message);
    }
    if (error.data.errors) {
      this.showAlert(error.data.errors);
    }
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('小樽市立病院個別帳票出力アラート');
  }
}
